import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled } from '@ori-ui/mui';
import { DealLabel } from "../../DealLabel";
import { PpaLabel } from "../../PpaLabel";
var BUNDLE_IMAGES_DESKTOP_PADDING = 10;
var BUNDLE_IMAGES_MOBILE_PADDING = 15;
var BUNDLE_IMAGE_DESKTOP_SIZE = 75;
var BUNDLE_IMAGE_MOBILE_SIZE = 115;
var BUNDLE_IMAGE_DESKTOP_OVERLAP = -40;
var BUNDLE_IMAGE_MOBILE_OVERLAP = BUNDLE_IMAGE_DESKTOP_OVERLAP * 2;
var PRODUCT_IMAGE_DESKTOP_WIDTH = 200;
export var Deal = styled(DealLabel)({
  left: '10px',
  position: 'absolute',
  top: '10px'
});
export var Ppa = styled(PpaLabel)({
  bottom: '0',
  position: 'absolute',
  width: '100%'
});
export var IconButtonWrapper = styled('div')({
  bottom: '15px',
  position: 'absolute',
  right: '15px'
});
export var ImageBoxRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    aspectRatio: '1/1',
    display: 'flex',
    position: 'relative',
    marginBottom: theme.spacing(3)
  }, theme.breakpoints.up('sm'), {
    display: 'inline',
    margin: theme.spacing(2, 0, 2, 2)
  });
});
export var ImageWrapper = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    borderRadius: '10px',
    height: '100%',
    backgroundColor: theme.palette.grey[100],
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    img: {
      maxHeight: '100%',
      objectFit: 'cover',
      maxWidth: '100%'
    }
  }, theme.breakpoints.up('sm'), {
    width: PRODUCT_IMAGE_DESKTOP_WIDTH
  });
});
export var BundleImage = styled('img')(function (_ref5) {
  var theme = _ref5.theme;
  return _defineProperty({
    aspectRatio: '1/1',
    border: "1px solid ".concat(theme.palette.grey[300]),
    borderRadius: '50%',
    display: 'block',
    height: BUNDLE_IMAGE_MOBILE_SIZE,
    position: 'relative',
    width: BUNDLE_IMAGE_MOBILE_SIZE
  }, theme.breakpoints.up('sm'), {
    height: BUNDLE_IMAGE_DESKTOP_SIZE,
    width: BUNDLE_IMAGE_DESKTOP_SIZE
  });
});
export var BundleImages = styled('div')(function (_ref7) {
  var theme = _ref7.theme;
  return _defineProperty({
    boxSizing: 'border-box',
    height: '100%',
    padding: "0 ".concat(BUNDLE_IMAGES_MOBILE_PADDING, "px"),
    width: '100%'
  }, theme.breakpoints.up('sm'), {
    padding: "0 ".concat(BUNDLE_IMAGES_DESKTOP_PADDING, "px")
  });
});
export var BundleImagesInner = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexFlow: 'column',
  gap: 0,
  height: '100%',
  justifyContent: 'center',
  lineHeight: 0,
  width: '100%'
});
export var BundleImagesRow = styled('div')(function (_ref9) {
  var theme = _ref9.theme;
  return _defineProperty({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    left: BUNDLE_IMAGE_MOBILE_OVERLAP / 2,
    width: '100%',
    '& + &': {
      marginTop: BUNDLE_IMAGE_MOBILE_OVERLAP
    },
    img: {
      marginRight: BUNDLE_IMAGE_MOBILE_OVERLAP
    }
  }, theme.breakpoints.up(400), {
    left: BUNDLE_IMAGE_DESKTOP_OVERLAP / 2,
    '& + &': {
      marginTop: BUNDLE_IMAGE_DESKTOP_OVERLAP
    },
    img: {
      marginRight: BUNDLE_IMAGE_DESKTOP_OVERLAP
    }
  });
});
//# sourceMappingURL=imageBox.js.map